import React, { useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

const Header = () => {
  const { t } = useLanguage();
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  const links = useMemo(() => [
    { to: '/', label: t('nav.home') },
    { to: '/services', label: t('nav.services') },
    { to: '/about', label: t('nav.about') },
    { to: '/gallery', label: t('nav.gallery') },
    { to: '/pricing', label: t('nav.pricing') },
    { to: '/contact', label: t('nav.contact') },
  ], [t]);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-[#e2e8f0] bg-white/90 backdrop-blur-xl">
      <div className="container-custom px-4 py-3 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2">
          <span className="text-2xl">🏥</span>
          <div>
            <p className="font-bold text-[#0f172a] leading-tight">Crystal Dental</p>
            <p className="text-xs text-[#64748b]">Luxury Smile Studio</p>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`px-3 py-2 rounded-lg text-sm font-medium ${pathname === l.to ? 'bg-[#0f172a] text-white' : 'text-[#475569] hover:text-[#0f172a] hover:bg-[#f1f5f9]'}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <LanguageSwitcher isScrolled />
          <Link to="/contact" className="btn-primary hidden sm:inline-flex">{t('nav.bookNow')}</Link>
          <button className="lg:hidden p-2 rounded-lg border border-[#cbd5e1] text-[#334155]" onClick={() => setOpen((p) => !p)}>
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden px-4 pb-4 grid gap-2 border-t border-[#e2e8f0] bg-white">
          {links.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="py-2 text-[#334155] font-medium">{l.label}</Link>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
